import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button, IconV2, Tag, Typography } from "@bookips/sds";
import Image from "next/image";
import { PassCategoryWithString } from "../../../api/membership";
import { PASS_CATEGORY_TAG_COLOR, PASS_CATEGORY_THUMBNAIL } from "./constants";
// 마이쏠북 이용권 관리 — 사용/기간만료 탭 카드
// requirements.md US.5: "이용권 모듈은 비활성화 처리. 클릭되는 요소는 이용권의 상세정보 버튼뿐."
// → 카드 전체(뱃지·썸네일·이름·이용가능 자료 보기) dim, 상세정보 버튼만 활성.
const ExpiredPassCard = (param)=>{
    let { pass , onOpenInfo  } = param;
    const { productInfo  } = pass;
    const category = productInfo.category;
    const { title  } = productInfo;
    const categoryLabel = PassCategoryWithString[category];
    const thumbnailSrc = PASS_CATEGORY_THUMBNAIL[category];
    // MX-583 — 상세정보 버튼 클릭 시
    const handleOpenInfo = ()=>{
        mixpanelEvent("Membership Info Button Clicked", {
            Position: "이용권 관리",
            "Button Name": "상세정보",
            "Membership Id": pass.membershipId,
            "Product Id": productInfo.id,
            Title: productInfo.title,
            Category: productInfo.category,
            "Remaining Days": pass.remainDay
        });
        onOpenInfo === null || onOpenInfo === void 0 ? void 0 : onOpenInfo(pass);
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "rounded-md border-b border-gray-50",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex w-full flex-col gap-5 p-5",
            children: [
                /*#__PURE__*/ _jsxs("div", {
                    className: "pointer-events-none flex flex-col gap-5 opacity-50",
                    children: [
                        /*#__PURE__*/ _jsx("div", {
                            className: "flex items-center gap-2",
                            children: /*#__PURE__*/ _jsx(Tag, {
                                color: PASS_CATEGORY_TAG_COLOR[category],
                                size: "sm",
                                bold: true,
                                children: categoryLabel
                            })
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "flex gap-4",
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "size-14 shrink-0 overflow-hidden rounded-lg border border-gray-300/20",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        src: thumbnailSrc,
                                        alt: title,
                                        width: 56,
                                        height: 56,
                                        className: "size-full object-cover"
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "flex flex-1 items-start",
                                    children: /*#__PURE__*/ _jsx(Typography, {
                                        variant: "subtitle1",
                                        className: "text-primary line-clamp-2",
                                        children: title
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "flex gap-1.5",
                    children: [
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "stroke",
                            color: "secondary",
                            size: "md",
                            onClick: handleOpenInfo,
                            children: "상세정보"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            variant: "stroke",
                            color: "secondary",
                            size: "md",
                            className: "w-full flex-1",
                            disabled: true,
                            rightElement: /*#__PURE__*/ _jsx(IconV2.ArrowRight, {
                                size: "xs"
                            }),
                            children: "이용권 사용하기"
                        })
                    ]
                })
            ]
        })
    });
};
export default ExpiredPassCard;
